import { render, staticRenderFns } from "./businessGood.vue?vue&type=template&id=24a89ed2&scoped=true"
import script from "./businessGood.vue?vue&type=script&lang=js"
export * from "./businessGood.vue?vue&type=script&lang=js"
import style0 from "./businessGood.vue?vue&type=style&index=0&id=24a89ed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a89ed2",
  null
  
)

export default component.exports